"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustedCybersecurityTechnologyConsultancyForTheUae() {
  const {
    ref: welcomeRef,
    isVisible: isWelcomeVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: companyRef,
    isVisible: isCompanyVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: headingRef,
    isVisible: isHeadingVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: paraRef,
    isVisible: isParaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: buttonsRef,
    isVisible: areButtonsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261981" id="trusted-cybersecurity-technology-consultancy-for-the-uae" className="bg-[#0B1220] text-white pt-10 pb-16 md:pt-14 md:pb-24 lg:pt-16 lg:pb-28 overflow-hidden">
      <div className="container mx-auto px-5 md:px-8 lg:px-16 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-[56%_36%] gap-8 md:gap-10 lg:gap-14 justify-between items-center max-w-full">
          
          <div className="flex flex-col items-start">
            <span ref={welcomeRef} className={`text-sm font-bold tracking-widest uppercase mb-3 text-[#4C8DFF] transition-all duration-700 ease-out ${isWelcomeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Future Experts for Technical Consultancy
            </span>
            
            <h1 ref={headingRef} className={`font-bold leading-[1.1] mb-8 text-[#FFFFFF] max-w-3xl transition-all duration-700 delay-200 ease-out text-5xl ${isHeadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Trusted Cybersecurity, AI and Digital Transformation Experts
            </h1>
            
            <p ref={paraRef} className={`text-lg md:text-xl text-[#D6DCE8] mb-8 max-w-xl leading-relaxed transition-all duration-700 delay-300 ease-out ${isParaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              We help organizations strengthen cybersecurity, modernize technology, develop secure software, and accelerate digital transformation through innovative, reliable, and future-ready solutions.
            </p>
            
            <div ref={buttonsRef} className={`flex flex-wrap gap-4 transition-all duration-700 delay-400 ease-out ${areButtonsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Button asChild size="lg" className="rounded-md px-8 py-6 text-base font-semibold bg-[#0F62FE] text-[#FFFFFF] hover:bg-[#0043CE] shadow-md transition-all hover:shadow-lg hover:-translate-y-1 border-none">
                <Link to="/ServicesSolutionsPage">Explore Our Solutions</Link>
              </Button>
              <Button asChild size="lg" className="rounded-md px-8 py-6 text-base font-semibold bg-[#0F62FE] text-[#FFFFFF] hover:bg-[#0043CE] shadow-md transition-all hover:shadow-lg hover:-translate-y-1 border-none">
                <Link to="/ContactUsPage">Talk to an Expert</Link>
              </Button>
            </div>
          </div>

          <div ref={imgRef} className={`relative h-[300px] lg:h-[425px] w-full max-w-full transition-all duration-1000 delay-500 ease-out ${isImgVisible ? "opacity-100" : "opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/fetc_enterprise_technology_consulting.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/fetc_enterprise_technology_consulting.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/fetc_enterprise_technology_consulting.png-wvc-sizes" alt="Professional enterprise technology infrastructure and digital transformation visualization" className="object-cover w-full h-full rounded-lg shadow-xl max-w-full" loading="lazy" />
          </div>
          
        </div>
      </div>
    </section>;
}